import { HERO_CARDS } from '@/mocks/chiliao';

const STATS = [
  { value: '128', label: '今日新更条目' },
  { value: '46', label: '收录合集分组' },
  { value: '2.4w', label: '本周围观人次' },
];

export default function Hero() {
  return (
    <section className="w-full" id="top">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        {/* 标题区 */}
        <div className="pt-12 md:pt-16">
          <div className="flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-60" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
              </span>
              每日 21:00 定时更新 · 今天也上新了
            </span>
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-fire-fill text-sm" />
              今日汇总
            </span>
          </div>

          <div className="mt-6 max-w-3xl">
            <h1 className="font-heading text-3xl font-black leading-snug tracking-tight text-foreground-950 md:text-5xl md:leading-tight">
              吃料，就看这一处
              <span className="block text-primary-600">今日汇总 · 热门合集 · 精选打包</span>
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-7 text-foreground-700 md:text-base">
              51吃料把今日汇总、热门合集、精选打包和完整列表都收拢进同一张页面——不用到处翻，点开即看、看完即走，最新整理的内容一次拿全。
            </p>
          </div>

          {/* 数据小条 */}
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {STATS.map((s) => (
              <div
                key={s.label}
                className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-1.5"
              >
                <span className="font-heading text-base font-bold text-accent-700">{s.value}</span>
                <span className="text-xs text-foreground-600">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* 首屏主导：多卡并列 */}
        <div className="mt-10 grid grid-cols-1 gap-4 pb-4 sm:grid-cols-2 lg:grid-cols-3 lg:pb-6">
          {HERO_CARDS.map((card) => (
            <a
              key={card.id}
              href={card.hot ? '#today' : '#hot'}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-100 transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={card.src}
                  alt={card.title}
                  title={`51吃料 · ${card.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-primary-800 backdrop-blur">
                  {card.hot && <i className="ri-fire-fill text-sm" />}
                  {card.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h2 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {card.title}
                </h2>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{card.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">{card.meta}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-700">
                    <i className="ri-chat-3-line text-sm" />
                    {card.comments}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}